import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  learningProgress: {
    id: 'progress.learningProgress',
    defaultMessage: 'Learning Progress',
    description: 'Progress page title',
  },
  fallbackCourseTitle: {
    id: 'progress.fallbackCourseTitle',
    defaultMessage: 'Course',
    description: 'Fallback title shown in the progress ongoing courses table when no course name is available',
  },
  loadingProgress: {
    id: 'progress.loadingProgress',
    defaultMessage: 'Loading progress',
    description: 'Screen reader text shown while the progress page is loading',
  },
  // --- Points / Leaderboard ---
  myPointsTitle: {
    id: 'progress.points.title',
    defaultMessage: 'My points',
    description: 'Title of the learner My points card',
  },
  myPointsRank: {
    id: 'progress.points.rank',
    defaultMessage: 'Rank #{rank} of {total}',
    description: 'Shows the learner rank and the total number of ranked learners',
  },
  myPointsUnranked: {
    id: 'progress.points.unranked',
    defaultMessage: 'Not ranked yet',
    description: 'Shown when the learner has no points in the selected window',
  },
  myPointsTotalLabel: {
    id: 'progress.points.totalLabel',
    defaultMessage: 'points',
    description: 'Unit label shown under the learner total points number',
  },
  pointsWindowWeek: {
    id: 'progress.points.window.week',
    defaultMessage: 'This week',
    description: 'Leaderboard time window option: current week',
  },
  pointsWindowMonth: {
    id: 'progress.points.window.month',
    defaultMessage: 'This month',
    description: 'Leaderboard time window option: current month',
  },
  pointsWindowAll: {
    id: 'progress.points.window.all',
    defaultMessage: 'All time',
    description: 'Leaderboard time window option: all time',
  },
  pointsBreakdownCompletion: {
    id: 'progress.points.breakdown.completion',
    defaultMessage: 'Completion',
    description: 'Label for points earned from completing course blocks',
  },
  pointsBreakdownSkills: {
    id: 'progress.points.breakdown.skills',
    defaultMessage: 'Skills',
    description: 'Label for points earned from gaining skills',
  },
  pointsBreakdownStreak: {
    id: 'progress.points.breakdown.streak',
    defaultMessage: 'Streak',
    description: 'Label for points earned from daily streaks',
  },
  leaderboardTitle: {
    id: 'progress.leaderboard.title',
    defaultMessage: 'Leaderboard',
    description: 'Title of the learner-facing org leaderboard section',
  },
  leaderboardColumnRank: {
    id: 'progress.leaderboard.column.rank',
    defaultMessage: 'Rank',
    description: 'Leaderboard table column header for rank',
  },
  leaderboardColumnLearner: {
    id: 'progress.leaderboard.column.learner',
    defaultMessage: 'Learner',
    description: 'Leaderboard table column header for the learner name',
  },
  leaderboardColumnTotalPoints: {
    id: 'progress.leaderboard.column.totalPoints',
    defaultMessage: 'Total points',
    description: 'Leaderboard table column header for total points',
  },
  leaderboardYou: {
    id: 'progress.leaderboard.you',
    defaultMessage: 'You',
    description: 'Badge marking the current learner row in the leaderboard',
  },
  leaderboardEmpty: {
    id: 'progress.leaderboard.empty',
    defaultMessage: 'No points earned yet. Complete blocks, earn skills, and keep your streak to climb the board.',
    description: 'Leaderboard empty state',
  },
});

export default messages;
